<style lang="scss">
@import '~scss/_variables';

.vue-dropdown {
    position: relative;
        z-index: 10;

    transition:
        max-height $transition-dropdown-height,
        opacity $transition-dropdown;

    &.slide-enter,
    &.slide-leave-to {
        opacity: 0;

        ul {
            transform: translate(0, -30px);
        }
    }

    ul {
        width: 100%;
        margin: 0;
        padding: 0;

        background: $color-black;
        list-style-type: none;

        transition: transform $transition-dropdown;
    }

        li {
            padding: 12px 20px 13px 20px;

            font-size: 18px;
            text-align: left;
            background: transparent;
            color: $color-white;

            cursor: pointer;
            transition: background $transition-hover;

            & + li {
                border-top: 1px solid $color-border-2;
            }

            &.is-selected {
                background: lighten($color-border-1, 5);
            }
        }
}
</style>

<template>
    <div
        ref="dropdown"
        :class="{
            'vue-dropdown': true,
            'is-active': isActive
        }"
        :style="{
            'max-height': dropdownHeight + 'px'
        }"
    >
        <transition-group name="item-transition" tag="ul">
            <li
                v-for="(item, index) in items"
                :key="item.id"
                :class="{
                    'vue-dropdown-item': true,
                    'is-selected': selected === index
                }"
                @mouseover="selectItem(index)"
                @click="chooseItem(index)"
            >
                <slot name="item" :data="item">
                    {{ item.id }}
                </slot>
            </li>
        </transition-group>
    </div>
</template>

<script>
import throttle from 'lodash.throttle';
import EventEmitter from 'event-emitter';

const
    emitter = EventEmitter(),
    sizeChange = throttle(function () {
        emitter.emit('viewportChange');
    }, 150);

window.addEventListener('resize', sizeChange);
window.addEventListener('scroll', sizeChange);

export default {
    props: {
        items: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            isActive: false,
            selected: null,
            dropdownHeight: null
        };
    },
    computed: {
        isEmpty () {
            return this.items.length === 0;
        }
    },
    mounted () {
        emitter.on('viewportChange', () => {
            this.updateHeight();
        });
    },
    methods: {
        open () {
            this.isActive = true;
        },
        close () {
            this.isActive = false;
        },
        selectPrevious () {
            if (this.selected > 0) {
                this.selected--;
            }
        },
        selectNext () {
            if (this.selected < this.items.length - 1) {
                this.selected++;
            }
        },
        selectItem (index) {
            if (this.items[index]) {
                this.selected = index;
            }
        },
        chooseItem (index) {
            if (typeof index !== 'number') {
                index = this.selected;
            }

            this.$emit('selected', this.items[this.selected]);
            this.close();
        },
        updateHeight () {
            var dropdown = this.$refs.dropdown;

            if (dropdown) {
                this.dropdownHeight = (
                    window.innerHeight - dropdown.getBoundingClientRect().top
                );
            }
        }
    },
    watch: {
        items (newValue) {
            if (newValue.length) {
                if (this.selected >= newValue.length) {
                    this.selected = newValue.length - 1;
                } else if (typeof this.selected !== 'number') {
                    this.selected = 0;
                }
            } else {
                this.selected = null;
            }
        }
    }
};
</script>
